import { Dialog } from "@mui/material";
import React from "react";
import './style.scss'
export const Modal = ({ open, handleClose, content }: any) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="modal-dialog"
    >
      {content}
    </Dialog>
  );
};
